module.exports = __webpack_public_path__ + "static/img/h_20@2x.7a0615ae.png";